function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SVG = void 0;
var _react = _interopRequireWildcard(require("react"));
var NativeSVG = _interopRequireWildcard(require("react-native-svg/lib/commonjs/ReactNativeSVG.web"));
var _reactNative = require("react-native-web");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var _tabIndex = _reactNative.Platform.OS === 'web' ? undefined : {
  tabIndex: -1
};
var _focusable = _reactNative.Platform.OS === 'web' ? undefined : false;
var Svg = (0, _react.memo)(function (props) {
  return (0, _jsxRuntime.jsx)(NativeSVG.Svg, Object.assign({}, props, _tabIndex, {
    focusable: _focusable,
    pointerEvents: "none",
    accessibilityRole: "image"
  }));
});
var G = (0, _react.memo)(function (props) {
  return (0, _jsxRuntime.jsx)(NativeSVG.G, Object.assign({}, props, _tabIndex));
});
var Defs = (0, _react.memo)(function (props) {
  return (0, _jsxRuntime.jsx)(NativeSVG.Defs, Object.assign({}, props, _tabIndex));
});
var ClipPath = (0, _react.memo)(function (props) {
  return (0, _jsxRuntime.jsx)(NativeSVG.ClipPath, Object.assign({}, props, _tabIndex));
});
var Image = (0, _react.memo)(function (props) {
  return (0, _jsxRuntime.jsx)(NativeSVG.Image, Object.assign({}, props, _tabIndex));
});
var Path = (0, _react.memo)(function (props) {
  return (0, _jsxRuntime.jsx)(NativeSVG.Path, Object.assign({}, props, _tabIndex));
});
var Circle = (0, _react.memo)(function (props) {
  return (0, _jsxRuntime.jsx)(NativeSVG.Circle, Object.assign({}, props, _tabIndex));
});
var Polygon = (0, _react.memo)(function (props) {
  return (0, _jsxRuntime.jsx)(NativeSVG.Polygon, Object.assign({}, props, _tabIndex));
});
var Rect = (0, _react.memo)(function (props) {
  return (0, _jsxRuntime.jsx)(NativeSVG.Rect, Object.assign({}, props, _tabIndex));
});
var Ellipse = (0, _react.memo)(function (props) {
  return (0, _jsxRuntime.jsx)(NativeSVG.Ellipse, Object.assign({}, props, _tabIndex));
});
var Text = (0, _react.memo)(function (props) {
  return (0, _jsxRuntime.jsx)(NativeSVG.Text, Object.assign({}, props, _tabIndex));
});
var TSpan = (0, _react.memo)(function (props) {
  return (0, _jsxRuntime.jsx)(NativeSVG.TSpan, Object.assign({}, props, _tabIndex));
});
var SVG = exports.SVG = {
  Svg: Svg,
  G: G,
  Path: Path,
  Circle: Circle,
  Polygon: Polygon,
  Rect: Rect,
  Ellipse: Ellipse,
  Text: Text,
  TSpan: TSpan,
  Defs: Defs,
  ClipPath: ClipPath,
  Image: Image
};